module.exports = __webpack_public_path__ + "img/Surveys _Offered Features.103c0e81.svg";